import React from "react";
import pic from "../images/github_logo.png";
import pic1 from "../images/linkedin_logo.png";
import pic2 from "../images/mail_logo.png";

const Footer = () => {
  return (
    <>
      <div id="footer" className="section-padding">
        <div className="bg-slate-800">
          <div className="row">
            <div className="col-4 text-neutral-300	text-4xl p-4 font-momo tracking-tighter	font-mono">
              Socials
            </div>
            <div className="col-7 mr-1">
              <div className="row py-2 px-0 flex justify-end items-end">
                <div className="col-2 lg:col-1">
                  <a href="https://github.com/fatma-sia27">
                    <img className="w-16 lg:w-10" src={pic} alt="" />
                  </a>
                </div>
                <div className="col-2 lg:col-1">
                  <a href="https://www.linkedin.com/in/aasia-fatma-7630b71bb/">
                    <img className="w-10" src={pic1} alt="" />
                  </a>
                </div>
                <div className="col-2 lg:col-1">
                  <a href="fatma.sia2020@gmail.com">
                    <img className="w-10" src={pic2} alt="" />
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="content-center text-center text-neutral-300 pb-4">
            <hr />
            <h2 className="pt-2">Designed and coded by  Fatma &#10084;</h2>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
